import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LanguageService } from '../../../tms-shared';
import { AuthService, IUser } from '../../services';
import { ApplicationPaths } from '../../constants';

@Component({
  selector: 'app-login-menu',
  styleUrl: 'login-menu.component.scss',
  templateUrl: 'login-menu.component.html',
})
export class LoginMenuComponent implements OnInit {
  @Input() isScannerApp = false;

  protected readonly ApplicationPaths = ApplicationPaths;

  public isAuthenticated$: Observable<boolean>;
  public userName$: Observable<string>;

  constructor(
    public languageService: LanguageService,
    protected authService: AuthService,
  ) {}

  ngOnInit() {
    this.isAuthenticated$ = this.authService.isAuthenticated();
    this.userName$ = this.authService
      .getUser()
      .pipe(map((u: IUser) => u && `${u.full_name ?? u.name}${u.customer_name ? ` - ${u.customer_name}` : ''}`));
  }

  translateMenu(value: string) {
    switch (value) {
      case 'Log in':
        return $localize`Log in`;
      case 'Log out':
        return $localize`Log out`;
    }
  }
}
